export const columnHeader = [
  {
    key: 'id', name: '#', type: 'text', system: true, filter: true
  },
  {
    key: 'name', name: 'Name', type: 'text', system: false, filter: true
  },
  {
    key: 'type', name: 'Type', type: 'text', system: true, filter: true
  },
  {
    key: 'number', name: 'Proxies', type: 'text', system: true, filter: true
  },
  {
    key: 'cost', name: 'Price (Units)', type: 'text', system: false, filter: true
  },
  {
    key: 'valid', name: 'Days', type: 'text', system: false, filter: true
  },
  {
    key: 'locations', name: 'Locations', type: 'text', system: true, filter: true
  },
  {
    key: 'subnets', name: 'Subnets', type: 'text', system: true, filter: true
  }
];

export const validDays = [
    {
        value: 1,
        label: '1 Day',
    },
    {
        value: 2,
        label: '2 Days',
    },
    {
        value: 3,
        label: '3 Days',
    },
    {
        value: 30,
        label: '30 Days',
    },
    {
        value: 60,
        label: '60 Days',
    },
    {
        value: 90,
        label: '90 Days',
    },
    {
        value: 365,
        label: '1 Year',
    }
];